import { render, staticRenderFns } from "./DocumentScannerModal.vue?vue&type=template&id=4706a854&scoped=true&"
import script from "./DocumentScannerModal.vue?vue&type=script&lang=js&"
export * from "./DocumentScannerModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentScannerModal.vue?vue&type=style&index=0&id=4706a854&prod&lang=scss&"
import style1 from "./DocumentScannerModal.vue?vue&type=style&index=1&id=4706a854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706a854",
  null
  
)

export default component.exports